/* eslint-disable no-unused-vars */
module.exports = function(type) {
  return function() {};
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/mocha/lib/browser/debug.js
 ** module id = 64
 ** module chunks = 1
 **/